<template>
    <v-navigation-drawer
        v-model="drawer"          
        width="600"
        app
        temporary
        right
        class="wost-drawer"
    >
        <div class="form-head">
            {{ titleForm }}
        </div>
        <div class="pl-3 pt-3 pr-3">
            <v-card>
                <v-card-text>
                    <template>
                        <v-row>
                            <v-col cols="12">
                                <v-data-table
                                    class="wost-table"
                                    :headers="headers"
                                    :items="products"
                                    hide-default-footer
                                    item-key="name"
                                    height="70vh"
                                    no-data-text=""
                                >
                                    <template v-slot:item.name="{ item }">
                                        {{ item.product_name }}
                                    </template>
                                    <template v-slot:item.quantity="{ item }">
                                        <v-text-field type="number" placeholder="0" v-model="item.quantity"></v-text-field>
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </template>
                </v-card-text>
            </v-card>
            <div class="mt-3" style="text-align: right;">
                <v-btn outlined color="red darken-1" @click="handleCancel">
                    Cancelar
                </v-btn>
                <v-btn v-if="actionCrud == 'recharge'" class="ml-3" dark color="primary" @click="handleSaveRechage">
                    Guardar
                </v-btn>
                <v-btn v-if="actionCrud == 'decrease'" class="ml-3" dark color="primary" @click="handleSaveDecrease">
                    Guardar
                </v-btn>
                <v-btn v-if="actionCrud == 'discharge'" class="ml-3" dark color="primary" @click="handleSaveDischarge">
                    Guardar
                </v-btn>
            </div>
        </div>

    </v-navigation-drawer>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

import ApiStorehouses from '../../apis/Storehouses'

export default {
    name: 'Movement',
    data() {
        return {
            titleForm: '',
            drawer: false,
            actionCrud: '',
            headers: [
                { text: 'Producto', value: 'name', align: 'left', sortable: false, class: 'header-table'},
                { text: 'Cantidad', value: 'quantity', align: 'left', sortable: false, class: 'header-table', width: 100}
            ],
            products: []
        }
    },
    computed: {
        ...mapState('storehouses', [
            'storehouseSelected',
            'productsMain'
        ]),
    },
    methods: {
        ...mapActions('storehouses', [
            'getProductsInStorehouse',
            'getProductsInStorehouseMain',
            'runSetStorehouseSelected'
        ]),
        showForm(title, actionCrud) {
            this.titleForm = title
            this.actionCrud = actionCrud
            this.getProductsInStorehouseMain()
            this.drawer = !this.drawer
            this.createProductsList()
        },
        createProductsList(){
            this.products = []
            this.productsMain.forEach(element => {
                let item = {
                    inventory_id: element.id,
                    product_id: element.product_id,
                    product_name: element.product.name,
                    quantity: null
                }
                this.products.push(item)
            });
        },
        handleCancel() {
            this.drawer = false
        },
        prepareData() {
            let productSend = []

            this.products.forEach(element => {
                if (element.quantity) {
                    productSend.push(element)
                }
            })
            
            let params = {
                storehouse_id: this.storehouseSelected.id,
                products: productSend                
            }

            return params
        },
        handleSaveRechage() {

            let params = this.prepareData()

            let validate = this.hasError(params.products)
            if(validate.error) {
                this.$notify({
                        group: 'foo',
                        type: 'error',
                        title: 'RESULTADO DE OPERACIÓN',
                        text: validate.message
                    })
            } else {
                ApiStorehouses.saveRecharge(params)
                    .then(({data}) => {                 
                        this.getProductsInStorehouse(this.storehouseSelected.id)
                        this.drawer = false
                        this.$notify({
                            group: 'foo',
                            type: 'success',
                            title: 'RESULTADO DE OPERACIÓN',
                            text: 'La recarga se realizó de manera exitosa!'
                        })
                    })
            }            
        },
        handleSaveDecrease() {
            let params = this.prepareData()

            let validate = this.hasError(params.products)
            if(validate.error) {
                this.$notify({
                        group: 'foo',
                        type: 'error',
                        title: 'RESULTADO DE OPERACIÓN',
                        text: validate.message
                    })
            } else {
                ApiStorehouses.saveDecrease(params)
                    .then(({data}) => {                 
                        this.getProductsInStorehouse(this.storehouseSelected.id)
                        this.drawer = false
                        this.$notify({
                            group: 'foo',
                            type: 'success',
                            title: 'RESULTADO DE OPERACIÓN',
                            text: 'El registro de merma se realizó de manera exitosa!'
                        })
                    })
            }
            
        },
        handleSaveDischarge() {
            let params = this.prepareData()

            let validate = this.hasError(params.products)

            if(validate.error) {
                this.$notify({
                        group: 'foo',
                        type: 'error',
                        title: 'RESULTADO DE OPERACIÓN',
                        text: validate.message
                    })
            } else {
                ApiStorehouses.saveDischarge(params)
                    .then(({data}) => {                 
                        this.getProductsInStorehouse(this.storehouseSelected.id)
                        this.drawer = false
                        this.$notify({
                            group: 'foo',
                            type: 'success',
                            title: 'RESULTADO DE OPERACIÓN',
                            text: 'El registro de descarga se realizó de manera exitosa!'
                        })
                    })
            }
        },
        hasError(products){
            let is_valid = false
            let message = ''
            if (products.length == 0) {
                is_valid = true
                message = 'Debe ingresar por lo menos una cantidad'
            }

            return {
                error: is_valid,
                message: message
            }
        }
    }
}
</script>

<style>

</style>